export default class AjaxError extends Error {
  code = 0

  constructor (msg, code) {
    super(msg || '未知错误')
    this.code = code
  }
}



// WEBPACK FOOTER //
// ./src/apis/ajax/AjaxError.js